<template lang="pug">
  .wrapper-answer(
    @click="toggleChoice(item)"
    :class="{'is-answer':(answer == item), 'is-not-answer':(answer != item), 'choice-selected':($parent.selectedChoice == item), 'show-mode':(showingAnswer)}"
  )
    .wrapper-circle
      span.as-circle
        i.fas.fa-check(
          v-if="$parent.selectedChoice == item && showingAnswer"
        )
        i.fas.fa-times(
          v-if="$parent.selectedChoice != item && showingAnswer"
        )
        span.suffix(v-if="!showingAnswer") {{suffix}}
    span.question {{item|fixdecimal}}
</template>

<script type="text/javascript">
import utils from "@/service/utils";

export default {
  name: "TestChoice",
  props: ["item", "showingAnswer", "answer", "suffix"],
  data() {
    return {};
  },
  methods: {
    toggleChoice(item) {
      if (this.showingAnswer) return;
      this.$parent.toggleChoice(item);
    },
  },
  filters: {
    fixdecimal: function (value) {
      return utils.fixdecimal(value);
    },
  },
};
</script>
